export const ctaLink = `ctaLink-> {
  title,
  linkType,
  internalLink,
  externalLink,
}`